import { render, staticRenderFns } from "./page-suggestion-confirmation.vue?vue&type=template&id=30957dd4"
import script from "./page-suggestion-confirmation.js?vue&type=script&lang=js&external"
export * from "./page-suggestion-confirmation.js?vue&type=script&lang=js&external"
import style0 from "./page-suggestion-confirmation.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports